<template>
  <div name="stdapplinf-detail-pg20">
    <div class="row">
      <div class="col-md-12">
        <div style="font-size: 16px; font-weight: 700; margin-bottom: 3px;">{{ labels['10'] }}</div>
        <hrms-table :columns="columns.pg20t1" :data="data" :selectRowBool="true" :tickEvent="rowEvent" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div style="font-size: 16px; font-weight: 700; margin-bottom: 3px;">{{ labels['80'] }}</div>
        <hrms-table :columns="columns.pg20t2" :data="dataTappoinf" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stdapplinf-detail-pg20',
  methods: {
    rowEvent (dataRow) {
      let searchParam = {
        numappl: dataRow.numappl,
        numreqrq: dataRow.numreqrq,
        codposrq: dataRow.codposrq
      }
      this.receivedStdapplinfTappoinf(searchParam)
    }
  },
  props: [ 'labels', 'data', 'columns', 'dataTappoinf', 'receivedStdapplinfTappoinf' ]
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg20.vue?7de6e373